import { useEffect, useState } from "react";

function Modal({ isOpen, onClose, children }) {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    if (isOpen) {
      setScrollY(window.scrollY); // capture where they are
      document.body.style.overflow = "hidden"; // prevent background scroll
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
      style={{ top: scrollY }} // place overlay at scroll position
      onClick={onClose}
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}

export default Modal;
